import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { useIsReusableBlocksEnabled } from "@/react/components/SettingsApp/Site/Pages/hooks/useIsReusableBlocksEnabled";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { IconButton } from "../../uikit/HeaderV3/IconButton";
import { SidebarHeader } from "../Sidebar/SidebarHeader";
import { SidebarHeaderTitle } from "../Sidebar/SidebarHeaderTitle";
import { BlockCategoryList } from "./BlockCategoryList";
import { BlockPreviewList } from "./BlockPreviewList";
import { ReusableBlockList } from "./ReusableBlockList";
import { useCategorizedBlockList } from "./useCategorizedBlockList";

export const BlockList = () => {
  const { blocks, closeSidebarView } = useBuilderStore(state => ({
    blocks: state.blockMapping,
    closeSidebarView: state.closeSidebarView,
  }));

  const {
    selectedCategory,
    allCategories,
    filteredBlocks,
    onClickCategoryHandler,
  } = useCategorizedBlockList({ blocks });
  const isReusableBlocksFeatureFlagEnabled = useIsReusableBlocksEnabled();
  const shouldAllowReusableBlocks = useBuilderStore(
    state => state.shouldAllowReusableBlocks,
  );
  const isReusableBlocksEnabled = Boolean(
    shouldAllowReusableBlocks && isReusableBlocksFeatureFlagEnabled,
  );

  const [shouldShowSavedBlocks, setShouldShowSavedBlocks] = useState(
    isReusableBlocksEnabled,
  );

  return (
    <div className="divide-primary flex h-full w-[33rem] flex-col divide-y">
      <SidebarHeader>
        <div className="flex w-full items-center justify-between">
          <SidebarHeaderTitle>
            {t("builder_ui.block_list.add_sections")}
          </SidebarHeaderTitle>
          <IconButton
            name="24-close"
            iconSize={24}
            ariaLabel={t("close")}
            onClick={closeSidebarView}
          />
        </div>
      </SidebarHeader>
      <div className="divide-primary flex h-full divide-x overflow-hidden">
        <BlockCategoryList
          categories={allCategories}
          selectedCategory={selectedCategory}
          onClickCategory={onClickCategoryHandler}
          shouldShowSavedBlocks={shouldShowSavedBlocks}
          setShouldShowSavedBlocks={setShouldShowSavedBlocks}
          isReusableBlocksEnabled={isReusableBlocksEnabled}
        />
        {shouldShowSavedBlocks ? (
          <ReusableBlockList />
        ) : (
          <BlockPreviewList blocks={filteredBlocks} />
        )}
      </div>
    </div>
  );
};
